import { CourierService } from "./../_services/courier.service";
import { State } from "./../_models/state";
import { Courier } from "./../_models/courier";
import { StateService } from "./../_services/state.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { ProductContent } from "../_models/product-content";
import { Location } from "@angular/common";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-state-page",
  templateUrl: "./add-state-page.component.html",
  styleUrls: ["./add-state-page.component.scss"],
})
export class AddStatePageComponent implements OnInit {
  public isModified = false;
  public newProductContent = new ProductContent();
  public state: State;
  public showAddContents = true;
  public couriers: Courier[];
  public selectedCountry: number = 0;
  public courierTypes = [
    {
      id: "DELIVERY",
      name: "Delivery",
    },
    { id: "PICKUP", name: "Pickup" },
    { id: "CORPORATE", name: "Corporate" },
  ];

  constructor(
    private location: Location,
    public snackBar: MatSnackBar,
    public stateService: StateService,
    public courierService: CourierService,
    private router: Router
  ) {}

  public back(): void {
    this.location.back();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public ngOnInit(): void {
    this.courierService.getCouriers().subscribe(
      (couriers) => {
        this.couriers = couriers;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve countries");
      }
    );
    this.state = new State();
    this.state.courierId = 0;
  }

  isStateValid() {
    return this.state.name && this.state.code;
  }

  public save(): void {
    if (!this.isStateValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.stateService.addState(this.state).subscribe(
      (state) => {
        this.showSuccessMessage("State was added successfully!");
        this.router.navigate(["regional", "states"]);
      },
      (err) => {
        console.error(err);
        if (err.status == 400) {
          this.showErrorMessage("Invalid values");
        } else {
          this.showErrorMessage(
            "Sorry, your request cannot be process at the moment!"
          );
        }
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public showSuccessMessage(message): void {
    this.snackBar.open(message, "Success", {
      duration: 2000,
    });
  }
}
